// # #############################################
// # Title : HUD Product
// # Authors : Sameer, Mahesh, Smit, Dhruv, Shubham
// # Date : 15th October 2019
// # Last Modified : Dhruv, September 2019
// # Version : 19.10.03
// # Description : This is the code for the HUD for the product details on the Marketing Side
// # ############################################

// Import the required Libraries

import React, { Component } from "react";
import "../css/App.css";
import StarRatings from "react-star-ratings";
import GlobalEvents from "../utils/global-events";
import config from "../utils/config";
import * as helperFunctions from "../utils/helperFunction";
import ReactTooltip from "react-tooltip";

function convertRange(value, r1, r2) {
  return ((value - r1[0]) * (r2[1] - r2[0])) / (r1[1] - r1[0]) + r2[0];
}

const productVol = [
  {
    "Product": "Tea",
    "VOlume": 16.9
  },
  {
    "Product": "Coffee",
    "VOlume": 9.5
  },
  {
    "Product": "Milk",
    "VOlume": 8
  },
  {
    "Product": "Water",
    "VOlume": 16.9
  },
  {
    "Product": "Fruit",
    "VOlume": 10
  },
  {
    "Product": "Carbonation",
    "VOlume": 12
  }
]

// HUD for the product details on the Marketing Side

class HUDproduct extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      // Default state for the Product HUD
      mappings: {
        // Mapping from the products in the data to the real names
        Coffee: "Coffee",
        Tea: "Tea",
        Carbonation: "Soft Drinks",
        Fruit: "Fruit Juice",
        Milk: "Milk",
        Water: "Water"
      },
      beverage_category: "Coffee",
      health: 7,
      taste: 9,
      pleasure: 9,
      image: "coffee.svg", // Fetch image name from the api and use it from the public
      addOns: [],
      "price": "$2.56",
      "manufacturing_cost": "$0.56",
      "profit_margin": "179"
    };
  }

  updateHUD() {
    fetch(config.api.url + "product/" + config.scenarioId, {
      // API to fetch the product details
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: `${config.token}`,
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({
          beverage_category: helperFunctions.convertToTitleCase(data.category),
          health: data.health,
          taste: data.taste,
          pleasure: data.pleasure,
          image: data.product_image ? data.product_image : "coffee.svg",
          addOns: data.addons
        });
      });
    this.updateHUDproductPricing();
  }
  updateHUDproductPricing() {
    fetch(config.api.url + "productPricing/" + config.scenarioId, {
      // API to fetch the product details
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: `${config.token}`,
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({
          price: parseFloat(data.cost_to_customer.replace("$", "")).toFixed(2),
          profit_margin: data.profit_margin,
          manufacturing_cost: data.manufacturing_cost
        });
      });
  }

  componentDidMount() {
    GlobalEvents.on("price_rerender", this.updateHUD.bind(this)); // Update product on component re render
    this.updateHUD();
  }

  render() {
    // const productInfo = JSON.parse(JSON.parse(JSON.stringify(sessionStorage.getItem('productData'))));
    let temp = "";
    // console.log(productInfo)

    // Self Explanatory
    return (
      <div id='proddiv'>
        <div
          className='productMainText'
          style={{ textAlign: "center", cursor: "default" }}
          id='divname'
        >
          Product : {this.state.mappings[this.state.beverage_category]} 
          <span>( {parseFloat(productVol.find(entry => entry.Product === this.state.beverage_category)['VOlume'].toFixed(2))} fl oz )</span>
        </div>
        <div className='productHUDContent'>
          <div className='productContentIcon'>
            <ReactTooltip
              class='producttt'
              id='producttt'
              getContent={dataTip => (
                <div className="tooltip-style">
                  <div style={{ margin: "2px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
                    <text><b>Product Information</b></text><br /><br />
                    <table style={{ textAlign: "left", overflowWrap: "break-word", marginTop: "1px" }}>
                      <tr>
                        <td><b style={{ color: "rgb(63, 81, 181)" }}>Category :</b></td>
                        <td />
                        <td>{this.state.beverage_category}</td>
                      </tr>
                      <tr />
                      <tr>
                        <td><b style={{ color: "rgb(63, 81, 181)" }}>Manufacturing cost: </b></td>
                        <td />
                        <td>${parseFloat(this.state.manufacturing_cost.replace('$', '')).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td><b style={{ color: "rgb(63, 81, 181)" }}>Volume: </b></td>
                        <td />
                        <td>{parseFloat(productVol.find(entry => entry.Product === this.state.beverage_category)['VOlume'].toFixed(2))} fl oz</td>
                      </tr>
                      <tr style={{ cols: "2" }}>
                        <td>
                          <b style={{ color: "rgb(63, 81, 181)" }}>Addons Selected </b>
                          <ul style={{ paddingTop: "0%", marginTop: "0%" }}>
                            {this.state.addOns.length !== 0 ? (
                              this.state.addOns.map(i => {
                                temp = i.split('_').join(' ');
                                temp = temp.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
                                return (
                                  <li>{temp}</li>
                                )
                              })
                            ) : (
                                <li>None</li>
                              )
                            }
                          </ul>
                        </td>
                      </tr>
                    </table>
                  </div>

                </div>
              )}
              effect='solid'
              place={"top"}
              border={true}
              type={"light"}
            />
            <img
              data-tip data-for='producttt'
              alt='product'
              style={{
                position: "absolute",
                height: "3vw",
                left: "-2%",
                bottom: "12%",
                cursor: "default"
              }}
              src={this.state.image}
            />
          </div>
          <div className='productContentText'>
            <div className='productHUDRatingLabels'>
              <div
                className='productHUDRatingsLabelsTxt'
                data-tip
                data-for='healthtip'
                style={{
                  fontSize: "0.8vw",
                  cursor: "default"
                }}
              >
                Health
              </div>
              <div
                className='productHUDRatingsLabelsTxt'
                data-tip
                data-for='tastetip'
                style={{
                  fontSize: "0.8vw",
                  cursor: "default"
                }}
              >
                Taste
              </div>
              <div
                className='productHUDRatingsLabelsTxt'
                data-tip
                data-for='pleasuretip'
                style={{
                  width: "fit-content",
                  fontSize: "0.8vw",
                  cursor: "default"
                }}
              >
                Pleasure
              </div>
            </div>
            <div className='productHUDRatings'>
              <StarRatings
                rating={convertRange(this.state.health, [1, 14], [0, 5])}
                starRatedColor='#344955'
                starEmptyColor='darkgrey'
                starDimension='1vw'
                starSpacing='0.001vw'
              />
              <StarRatings
                style={{
                  position: "absolute",
                  left: "55%"
                }}
                rating={convertRange(this.state.taste, [1, 12], [0, 5])}
                starRatedColor='#344955'
                starEmptyColor='darkgrey'
                starDimension='1vw'
                starSpacing='0.001vw'
              />
              <StarRatings
                style={{
                  position: "absolute",
                  left: "55%"
                }}
                rating={convertRange(this.state.pleasure, [2, 11], [0, 5])}
                starRatedColor='#344955'
                starEmptyColor='darkgrey'
                starDimension='1vw'
                starSpacing='0.001vw'
              />
            </div>
          </div>
        </div>

        <ReactTooltip
          class='temperaturetooltip'
          id='healthtip'
          getContent={dataTip => (
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  width: 150,
                  wordWrap: "break-word",
                  marginBottom: "2px"
                }}
              >
                On a scale of 0-11, the overall wellbeing(physical and mental)
                the beverage provides to the customer
              </div>
            </div>
          )}
          effect='solid'
          place={"top"}
          border={true}
          type={"light"}
        />
        <ReactTooltip
          class='temperaturetooltip'
          id='tastetip'
          getContent={dataTip => (
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  width: 150,
                  wordWrap: "break-word",
                  marginBottom: "2px"
                }}
              >
                General perception of taste among the consumers on a scale of
                0-11
              </div>
            </div>
          )}
          effect='solid'
          place={"top"}
          border={true}
          type={"light"}
        />
        <ReactTooltip
          class='temperaturetooltip'
          id='pleasuretip'
          getContent={dataTip => (
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  width: 150,
                  wordWrap: "break-word",
                  marginBottom: "2px"
                }}
              >
                How addictive the drink is based on the presence of ingredients
                like dopamine. Measured on a scale of 0-11
              </div>
            </div>
          )}
          effect='solid'
          place={"top"}
          border={true}
          type={"light"}
        />
      </div>
    );
  }
}

export default HUDproduct;
